import React from "react";

export default function ProjectCoordinatorDetails({ name, email, phone }) {
  return (
    <>
      <p className="font-14-NunitoSans-800 mb-10">Project Coordinator</p>
      <p className="font-16-NunitoSans-600 mt-common-card__content-block-2-text-3">
        <img src="/img/desktop/icons/white-person-icon.svg" alt="" />
        {name}
      </p>
      <p className="font-16-NunitoSans-600 mt-common-card__content-block-2-text-3">
        <img src="/img/desktop/icons/white-message-icon.svg" alt="" />
        {email}
      </p>
      <p className="font-16-NunitoSans-600 mt-common-card__content-block-2-text-3">
        <img src="/img/desktop/icons/white-call-icon.svg" alt="" />
        {phone}
      </p>
    </>
  );
}
